import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from '../../headersService'


export const getAllNotifications = createAsyncThunk('getAllNotifications', async (obj, { rejectWithValue }) => {
    try {
        const { data } = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/notifications`);
        return data
    } catch (error) {
        console.log(error)
        return rejectWithValue(error)
    }
})

export const notificationSlice = createSlice({
    name: 'notifications',
    initialState: {
        loading: false,
        notifications: [],
        error: null
    },
    extraReducers: (builder) => {
        builder.addCase(getAllNotifications.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getAllNotifications.fulfilled, (state, action) => {
            state.loading = false;
            state.notifications = action.payload
        })
        builder.addCase(getAllNotifications.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload
        })
    }
})

export default notificationSlice.reducer